export const HOME = 'home'
export const COURSES = 'courses'
export const PROFESSIONS = 'professions'
export const NEW = 'new'
export const LEARNING_TRACKING = 'learningTracking'
export const LEARNING_TRACKING_MAIN = 'learningTrackingMain'
export const STUDENTS_LAYOUT = 'studentsLayout'
export const ASSESSMENTS = 'assessments'
export const STUDENT_TRACKING = 'studentTracking'
export const LESSON = 'lesson'
export const LESSONS = 'lessons'
export const SUBMISSION = 'submission'
export const SUBMISSIONS = 'submissions'
export const EDIT_LESSON = 'editLesson'
export const MATERIAL_LIBRARY = 'materialLibrary'
export const CURRICULUM = 'curriculum'
export const CURRICULUMS = 'curriculums'
export const PROJECT = 'project'
export const PROJECT_CODE = 'projectCode'
export const TRAINING_ROOM = 'trainingRoom'
export const PROJECTCODE = 'projectCode'
export const LESSONPROJECT = 'lessonProject'
export const CONNECT = "connect"
export const CBLESSON = 'cblesson'
export const ADMIN = 'admin'
export const GUIDE = 'guide'
export const MESSAGES = 'messages'
export const DISCIPILINES = 'disciplines'
export const POSTS = 'posts'
export const STUDENT_BANNER = 'studentBanner'
export const TEACHER_BANNER = 'TeacherBanner'
export const TRANINGS = 'trainings'
export const TEAMS = 'teams'
